import React, { Component } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../shared/firebase';
import { ParseContract } from '../../services/ParseContract';
import { Loading, ErrorMessage } from '../../shared/layout';
import { getRouteParam } from '../../utils';
import { PollQuestion } from '../poll-question/PollQuestion';
import { thorify } from "thorify";
import { asciiToHex } from '../../services/utilities';
import { testNetPollContractAddress, pollContractAbi, mainNetPollContractAddress } from '../../contractsData/pollContract';
import { mainNetProviderUrl, testNetProviderUrl } from '../../contractsData/providers';

class PollDetailsBase extends Component {

  state = {
    poll: null,
    loading: true,
    error: null,
  }

  getInitialResults(questions) {
    return (questions || []).map(question => {
      return (question.answers || []).map(answer => 0);
    })
  }

  getResultsData(results, questions, usingWeb3 = false) {
    const initialResults = this.getInitialResults(questions);

    results.forEach(result => {
      let userVotes;
      if (usingWeb3) {
        userVotes = result && result.returnValues && result.returnValues.result;
      } else {
        userVotes = result && result.decoded && result.decoded.result;
      }

      (userVotes || []).forEach((vote, index) => {
        const numberVote = parseInt(vote, 10)
        if (initialResults[index]) {
          initialResults[index][numberVote] = initialResults[index][numberVote] + 1;
        }
      });
    });

    return initialResults;
  }

  getPollId = () => getRouteParam(this.props, 'id');

  componentDidMount() {
    const pollId = this.getPollId();
    let pollData = null;

    this.props.firebase.getPoll(pollId)
      .then(poll => {

        this.setState({ poll });
        pollData = poll;
        return poll;
      })
      .then(poll => poll.net || 'TEST')
      .then(net => {
        if (!window.connex) {
          const Web3 = require("web3");
          const web3 = thorify(new Web3(), net === 'MAIN' ? mainNetProviderUrl : testNetProviderUrl);
          const address = net === 'MAIN' ? mainNetPollContractAddress : testNetPollContractAddress;
          const pollContractWeb3 = new web3.eth.Contract(pollContractAbi, address);
          pollContractWeb3.getPastEvents('Vote', { filter: { pollId: asciiToHex(pollId) } })
            .then(results => {
              const votesCount = results && results.length;
              const data = this.getResultsData(results, pollData.questions, true);
              this.setState({ loading: false, votesCount, data });
            });
          return;
        }

        const address = net === 'MAIN' ? mainNetPollContractAddress : testNetPollContractAddress;
        const contract = new ParseContract(pollContractAbi, address, window.connex);

        const event = contract.getEvent('Vote');
        const filter = event.filter([{
          pollId: asciiToHex(pollId),
        }]);

        return filter.apply(0, 256)
          .then(results => {
            const votesCount = results && results.length;
            const data = this.getResultsData(results, pollData.questions);

            this.setState({ loading: false, votesCount, data });
          });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          error: 'GENERIC_ERROR',
          loading: false
        });
      });
  };

  render() {
    const { poll, loading, data, votesCount, error } = this.state;

    return loading ? <div className="loading-page-content"><Loading /></div> :
      error ? <div className="error-page-content"><ErrorMessage message={error} /></div> : (
      <div className="mdl-grid">
        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop">
          <div className="mdl-card__title mdl-color--primary mdl-color-text--white" style={{flexDirection: 'column'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
              <h2 className="mdl-card__title-text">{poll.name}</h2>
              <h2 className="mdl-card__title-text">Votes: {votesCount}</h2>
            </div>

            <div className="app-divider"></div>
            <p>{poll.description}</p>
          </div>
          <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={{width: 'initial'}}>
            {(poll.questions || []).map((question, index) => (
              <div key={`${question.name}_${index}`}>
                <PollQuestion question={question} data={data[index]} votesCount={votesCount} index={index} />
                <div className="app-divider"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
};

export const PollDetails = compose(withRouter, withFirebase)(PollDetailsBase);
